var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgProfileInterests = function SvgProfileInterests(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.7992 19.3822C36.7992 24.3548 34.8359 28.8566 31.6617 32.1153L19.2586 44.8483L6.8556 32.1152C3.68138 28.8565 1.71802 24.3548 1.71802 19.3822C1.71802 9.43713 9.5712 1.37503 19.2586 1.37503C28.946 1.37503 36.7992 9.43713 36.7992 19.3822ZM22.5982 12.7529C21.294 12.7529 20.1133 13.2955 19.2587 14.173C18.404 13.2955 17.2233 12.7529 15.9191 12.7529C13.3107 12.7529 11.1962 14.9236 11.1962 17.6014C11.1962 18.9403 11.7248 20.1524 12.5795 21.0298L19.2586 27.8866L25.9377 21.0298C26.7924 20.1523 27.321 18.9402 27.321 17.6014C27.321 14.9236 25.2066 12.7529 22.5982 12.7529Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProfileInterests);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "profile_interests.0cd729fd42822cc8516c911a7a43f396.svg";